import { apiClientGeral } from '@/plugins/axios'

export default {
  getFirewallConfig() {
    return apiClientGeral().get('/config')
  },

  putFirewallConfig(data) {
    return apiClientGeral().put('/config', data)
  },

  getIpsBlocked() {
    return apiClientGeral().get('/firewallip')
  },
  deleteOneIp(id) {
    return apiClientGeral().delete(`/firewallip/${id}`)
  },
  deleteAllIps() {
    return apiClientGeral().delete('/firewallip/all')
  },
  deleteSelectedIps(data) {
    return apiClientGeral().post('/firewallip/byarray?_method=DELETE', data)
  },
}
